import * as Yup from "yup";

const LoginSchema = Yup.object().shape({
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  email: Yup.string().email("Invalid email").required("Required"),
  checkbox: Yup.boolean().oneOf([true], "Required"),
});

export default LoginSchema;
